import React from 'react';
import PropTypes from 'prop-types';

import './Switch.css';

const Switch = ({
    checked,
    classes,
    color,
    disabled,
    id,
    inputRef,
    onChange,
    required,
    size,
}) => {
    return (
        <label htmlFor={id} className="ab-toggle-switch">
            <input
                type="checkbox"
                name="hey"
                id={id}
                onChange={onChange}
                checked={checked}
            />
            <span className="ab-toggle-thumb"></span>
        </label>
    );
};

Switch.propTypes = {
    checked: PropTypes.bool,
    classes: PropTypes.string,
    color: PropTypes.string,
    disabled: PropTypes.bool,
    id: PropTypes.string.isRequired,
    inputRef: PropTypes.oneOfType([
        PropTypes.func,
        PropTypes.shape({ current: PropTypes.instanceOf(HTMLInputElement) }),
    ]),
    onChange: PropTypes.func,
    required: PropTypes.bool,
    size: PropTypes.oneOf(['large', 'medium', 'small']),
};

export default Switch;
